<template>
  <article class="example-page">
    <h1>Account graph</h1>
    <form @submit.prevent>
      <label for="balance">Balance</label>
      <input id="balance" v-model="balance" placeholder="Balance">
      <label for="cashflows">Cashflows</label>
      <input id="cashflows" v-model="cashflows" placeholder="Cashflows">
      <label for="ror">Rate of return</label>
      <input id="ror" v-model="ror" placeholder="Rate of return">
      <label for="gains">Gains</label>
      <input id="gains" v-model="gains" placeholder="Gains">
      <label for="timeframe">Time frame</label>
      <select id="timeframe" v-model="timeframe" placeholder="Timeframe" type="select">
        <option value="all">All</option>
        <option value="1M">1 month</option>
        <option value="6M">6 months</option>
        <option value="1Y">1 year</option>
        <option value="YTD">Year to date</option>
      </select>
      <label for="dates">Dates</label>
      <textarea id="dates" v-model="datesField" placeholder="Dates" />
      <label for="balances">Balances</label>
      <textarea id="balances" v-model="balancesField" placeholder="Balances" />
      <label for="contributions">Contributions</label>
      <textarea id="contributions" v-model="contributionsField" placeholder="Contributions" />
    </form>
    <account-graph
      class="graph"
      :balance="parseFloat(balance)"
      :cashflows="parseFloat(cashflows)"
      :ror="parseFloat(ror)"
      :gains="parseFloat(gains)"
      :timeframe="timeframe"
      :dates="dates"
      :balances="balances"
      :contributions="contributions"
    />
  </article>
</template>

<script>
import { accountGraph } from '@/components/advisor';

export default {
  components: { accountGraph },
  data() {
    return {
      balance: 1234,
      cashflows: 1010,
      ror: 5.67,
      gains: 224,
      timeframe: 'all',
      datesField: JSON.stringify(['Apr 3 2016', 'Apr 4 2016', 'Apr 5 2016', 'Apr 6 2016', 'Apr 7 2016', 'Apr 8 2016', 'Apr 9 2016', 'Apr 10 2016', 'Apr 11 2016', 'Apr 12 2016']),
      balancesField: JSON.stringify([4000, 4500, 4900, 6100, 6000, 5800, 6700, 7000, 7250, 7500]),
      contributionsField: JSON.stringify([4000, 4200, 4200, 4600, 4600, 4600, 4800, 4900, 4900, 5000]),
    };
  },
  computed: {
    dates() {
      return JSON.parse(this.datesField);
    },
    balances() {
      return JSON.parse(this.balancesField);
    },
    contributions() {
      return JSON.parse(this.contributionsField);
    },
  },
};
</script>

<style lang="scss" scoped>


  .graph {
    margin: 0 auto;
    border: 1px solid black;
    max-width: 70rem;
    margin-top: 2rem;
  }

</style>
